import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowRight } from 'lucide-react';
function GoogleGIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-362" data-mp="20t9u1ltc6r58">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-363" data-mp="1mziv17d8epnr" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-364" data-mp="1d1l4uebtaisi" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-365" data-mp="141ohcg15rpz1" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-366" data-mp="2yfgxgsdwmdg0" />
    </svg>;
}
interface Testimonial {
  code: string;
  name: string;
  service: string;
  rating: number;
  quote: string;
  date: string;
}
const testimonials: Testimonial[] = [{
  code: 'REV-01',
  name: 'Олександр Ковальчук',
  service: 'Ремонт двигуна · BMW E60',
  rating: 5,
  quote: 'Жодних зайвих робіт і прихованих платежів. Чесно показали проблему, узгодили кошторис і виконали все точно у строк. Нарешті майстерня, де говорять з тобою як з людиною.',
  date: '12.03.2025'
}, {
  code: 'REV-02',
  name: 'Марія Левченко',
  service: 'Діагностика та підвіска · VW Passat',
  rating: 5,
  quote: 'Приїхала з підозрою на серйозну поломку. Інші СТО пропонували міняти пів машини, а тут спокійно продіагностували й полагодили те, що дійсно було потрібно. Ціна — справедлива.',
  date: '28.02.2025'
}, {
  code: 'REV-03',
  name: 'Дмитро Іщенко',
  service: 'Ремонт турбіни · Audi A4',
  rating: 5,
  quote: 'Військовий підхід відчутний у всьому — від запису до видачі авто. Звітували по кожному етапу, дотрималися строків до години. Професіоналізм найвищого рівня.',
  date: '15.02.2025'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-zinc-950 text-white py-24 px-6 md:px-12 lg:px-20 border-t border-white/5" data-id="element-367" data-mp="dd80576e6sin">
      <div className="max-w-7xl mx-auto" data-id="element-368" data-mp="ibj8fdh1guyr">
        {/* Header */}
        <div className="mb-12" data-id="element-369" data-mp="3gu6x2huxmbej">
          <div className="flex items-center gap-3 mb-4" data-id="element-370" data-mp="3gv8b8v78ve0h">
            <div className="w-2 h-2 bg-[#6B7A4A] rounded-full pulse-dot" data-id="element-371" data-mp="3ls8hb643ggrl" />
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest uppercase" data-id="element-372" data-mp="3lqf6demg7ads">
              Відгуки · Google Карти
            </span>
          </div>
          <h2 className="font-['Oswald'] text-5xl md:text-6xl font-bold uppercase tracking-widest mb-3 flex items-center gap-4" data-id="element-373" data-mp="3vjw1qn28gxjk">
            Відгуки в Google
          </h2>
          <p className="text-zinc-500 text-sm max-w-2xl" data-id="element-374" data-mp="3318oftthamt1">
            Реальні відгуки людей, які довірили нам свої автомобілі. Чесно, без
            прикрас.
          </p>
        </div>

        {/* Summary Block */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-12 pb-8 border-b border-white/10 gap-6" data-id="element-375" data-mp="1g62aw7fnypts">
          <div className="flex items-center gap-6" data-id="element-376" data-mp="167d3j8le8nrs">
            <div className="font-['Oswald'] text-6xl font-bold text-white leading-none" data-id="element-377" data-mp="166lbg7r09869">
              5.0
            </div>
            <div className="flex flex-col gap-1" data-id="element-378" data-mp="11aee33cod4zx">
              <div className="flex items-center gap-1" data-id="element-379" data-mp="whbdwcde6xar">
                {Array.from({
                length: 5
              }).map((_, i) => <Star key={i} className="w-5 h-5 fill-[#FBBC04] text-[#FBBC04]" data-id="element-380" data-mp="sdlu007nx3w2" data-mpi={i} />)}
              </div>
              <span className="font-['JetBrains_Mono'] text-xs text-zinc-400 tracking-wider" data-id="element-381" data-mp="ih0o7cntjor6">
                на основі 248 відгуків в Google
              </span>
            </div>
          </div>

          <a href="https://www.google.com/maps/search/?api=1&query=Win+Code+Garage+Хмельницький" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 bg-white/5 hover:bg-white/10 border border-white/10 transition-colors duration-200 py-3 px-6" data-id="element-382" data-mp="2dlgtyct0h7ch">
            <GoogleGIcon className="w-5 h-5" data-id="element-383" data-mp="1uugyqtuxb1ar" />
            <span className="font-['Oswald'] text-sm uppercase tracking-widest text-white" data-id="element-384" data-mp="1uto0kha15k48">
              Читати всі відгуки в Google
            </span>
            <ArrowRight className="w-4 h-4 text-zinc-400 group-hover:translate-x-1 transition-transform duration-200" data-id="element-385" data-mp="1kwb0cm8bsdan" />
          </a>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-386" data-mp="1pxgumohmw8ma">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.code} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1,
          ease: 'easeOut'
        }} className="group relative bg-neutral-900/50 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 p-7 flex flex-col" data-id="element-387" data-mp="3k9x6c4t78eyj" data-mpi={index}>
              {/* Corner brackets */}
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-388" data-mp="1ndasmmckys8d" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-389" data-mp="1wbmp3504ok8q" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-390" data-mp="6wolxdyo4r3y" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-391" data-mp="1xli1wufcqxk" />

              {/* Header row: Avatar + Name + Date */}
              <div className="flex items-start gap-4 mb-5" data-id="element-392" data-mp="221pc6wkt4hjj">
                <div className="w-12 h-12 rounded-full shrink-0 bg-[#6B7A4A] flex items-center justify-center" data-id="element-393" data-mp="26y60bqs0avwm">
                  <span className="font-['Oswald'] text-lg font-bold text-white uppercase tracking-wider" data-id="element-394" data-mp="2azhqbxeslj5c">
                    {testimonial.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
                  </span>
                </div>
                <div className="flex-1 min-w-0 pt-1" data-id="element-395" data-mp="2pvpbp11xsqm7">
                  <div className="font-['Oswald'] text-base uppercase tracking-wide text-white truncate" data-id="element-396" data-mp="2uoa3jx1a8tn3">
                    {testimonial.name}
                  </div>
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-1" data-id="element-397" data-mp="33p8bgqeudlay">
                    {testimonial.date}
                  </div>
                </div>
                <GoogleGIcon className="w-5 h-5 shrink-0 opacity-80" data-id="element-398" data-mp="3is8875s25o09" />
              </div>

              {/* Rating */}
              <div className="flex items-center gap-0.5 mb-4" data-id="element-399" data-mp="3dslvcxg569rz">
                {Array.from({
              length: testimonial.rating
            }).map((_, i) => <Star key={i} className="w-4 h-4 fill-[#FBBC04] text-[#FBBC04]" data-id="element-400" data-mp="34sgsn0lw7zk5" data-mpi={i} />)}
              </div>

              {/* Quote text */}
              <p className="text-zinc-300 text-base leading-relaxed font-['Inter'] mb-6 flex-1" data-id="element-401" data-mp="dqouzebc403">
                {testimonial.quote}
              </p>

              {/* Footer: service tag */}
              <div className="pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-402" data-mp="3nrkunpf0ot2b">
                <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase truncate" data-id="element-403" data-mp="o3l1pgymtskc">
                  {testimonial.service}
                </span>
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-404" data-mp="jba3qjngcguf">
                  <span className="font-['JetBrains_Mono'] text-[9px] text-zinc-600 tracking-wider uppercase" data-id="element-405" data-mp="12zkactrjisyr">
                    Опубліковано в Google
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Trust strip */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-12 pt-8 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-406" data-mp="y2k4aiuoxq7n">
          {[{
          value: '100%',
          label: 'Чесна оцінка'
        }, {
          value: '0',
          label: 'Нав\u2019язаних робіт'
        }, {
          value: '24Г',
          label: 'Зворотний зв\u2019язок'
        }, {
          value: '5.0',
          label: 'Середній рейтинг'
        }].map(stat => <div key={stat.label} className="flex flex-col" data-id="element-407" data-mp="2sm3v8we4c4tl">
              <div className="font-['Oswald'] text-3xl md:text-4xl font-bold text-[#6B7A4A]" data-id="element-408" data-mp="2ok8xg1vec9kk">
                {stat.value}
              </div>
              <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase mt-2" data-id="element-409" data-mp="20vpp5mccjwsh">
                {stat.label}
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}